import React, { useState } from "react";

import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import LoadingButton from "@mui/lab/LoadingButton";
import TextField from "@mui/material/TextField";
import Card from "@mui/material/Card";

import useRequest from "../../apiServices/useRequest";
import ListCta from "../../components/common/ListCta";
import ToasterMessage from "../../components/common/ToasterMessage";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router-dom";

import CircularProgress from "@mui/material/CircularProgress";

import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

const intData = {
  name: "",
  bnName: "",
  serviceCode: "",
  description: "",
  bnDescription: "",
  image: "",
  isFeatured: "",
  isActive: "",
};
const Create = () => {
  let navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState(intData);
  const [preview, setPreview] = useState("");
  const [image, setImage] = useState([]);
  const [postRequest] = useRequest();

  const editorConfig = {
    placeholder: "Type your description in bangla...",
  };

  const editorConfig1 = {
    placeholder: "Type your description in english...",
  };

  const handleImageChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      const fileExtension = selectedFile.name.split(".").pop().toLowerCase();

      if (fileExtension === "webp") {
        const files = [...image];
        files.push(...event.target.files);
        setImage([...files]);
        setPreview(URL.createObjectURL(event.target.files[0]));
      } else {
        ToasterMessage("Please select a webp image file.", "error");
        event.target.value = null;
      }
    }
  };

  const handleSubmit = () => {
    //console.log("the expected data is", data.image[0]);

    if (
      data.name !== "" &&
      data.bnName !== "" &&
      data.serviceCode !== "" &&
      data.description !== "" &&
      data.bnDescription !== "" &&
      data.isFeatured !== "" &&
      data.isActive !== "" &&
      data.image !== ""
    ) {
      setIsLoading(true);

      let formData = new FormData();
      formData.append("name", data.name);
      formData.append("bnName", data.bnName);
      formData.append("serviceCode", data.serviceCode);

      formData.append("description", data.description);
      formData.append("bnDescription", data.bnDescription);
      image.forEach((ele) => {
        formData.append("image", ele);
      });
      formData.append("isFeatured", data.isFeatured);
      formData.append("isActive", data.isActive);

      postRequest("service", formData)
        .then((res) => {
          ToasterMessage("Data saved successfully!", "success");
          setIsLoading(false);
          navigate("/service");
        })
        .catch((err) => {
          ToasterMessage("Error Try Again!", "error");
          setIsLoading(false);
        });
    } else {
      ToasterMessage("Please fill up all the required fields", "warning");
    }
  };

  if (isLoading === true)
    return (
      <h2>
        Loading... <CircularProgress />
      </h2>
    );

  return (
    <>
      <ListCta path="/service" title="Service Create" btnName="Service List" />
      <Container>
        <Grid container>
          <Grid item xs={12} md={10} sx={{ m: "auto" }}>
            <Card sx={{ px: 5, py: 3 }}>
              <Box>
                <Typography variant="caption" display="block">
                  English Name
                </Typography>
                <TextField
                  variant="outlined"
                  placeholder="English Name"
                  sx={{ width: "100%", mb: 2 }}
                  size="small"
                  onChange={(e) =>
                    setData((pre) => ({ ...pre, name: e.target.value }))
                  }
                  required
                />
              </Box>

              <Box>
                <Typography variant="caption" display="block">
                  Bangla Name
                </Typography>
                <TextField
                  variant="outlined"
                  placeholder="Bangla Name"
                  sx={{ width: "100%", mb: 2 }}
                  size="small"
                  onChange={(e) =>
                    setData((pre) => ({ ...pre, bnName: e.target.value }))
                  }
                  required
                />
              </Box>

              <Box>
                <Typography variant="caption" display="block">
                  Service Code
                </Typography>
                <TextField
                  variant="outlined"
                  placeholder="Service Code"
                  sx={{ width: "100%", mb: 2 }}
                  size="small"
                  onChange={(e) =>
                    setData((pre) => ({ ...pre, serviceCode: e.target.value }))
                  }
                  required
                />
              </Box>

              <Box>
                <Typography variant="caption" display="block">
                  Description
                </Typography>
                <CKEditor
                  editor={ClassicEditor}
                  data={data.description}
                  config={editorConfig1}
                  onChange={(e, editor) =>
                    setData((pre) => ({
                      ...pre,
                      description: editor.getData(),
                    }))
                  }
                />
              </Box>

              <Box sx={{ mt: 2 }}>
                <Typography variant="caption" display="block">
                  Bangla Description
                </Typography>
                <CKEditor
                  editor={ClassicEditor}
                  data={data.bnDescription}
                  config={editorConfig}
                  onChange={(e, editor) =>
                    setData((pre) => ({
                      ...pre,
                      bnDescription: editor.getData(),
                    }))
                  }
                />
              </Box>

              {/* <TextField
                  variant="outlined"
                  label="Description"
                  placeholder="Description"
                  sx={{ width: "100%", mb: 2 }}
                  size="small"
                  {...register("description")}
                /> */}
              <div style={{ display: "flex", padding: "3px" }}>
                {preview && (
                  <img
                    src={preview}
                    size="small"
                    width="300px"
                    style={{ padding: "3px" }}
                    alt="no chinta"
                  />
                )}
              </div>

              <Box>
                <Typography variant="caption" display="block">
                  Image
                </Typography>
                <TextField
                  variant="outlined"
                  name="Image"
                  onChange={handleImageChange}
                  type="file"
                  accept=".webp"
                  size="small"
                  sx={{ width: "100%", mb: 2 }}
                />
              </Box>
              {/* <TextField
                  variant="outlined"
                  label="IsFeatured"
                  sx={{ width: "100%", mb: 2 }}
                  size="small"
                  {...register("isFeatured")}
                /> */}
              {/* <FormControlLabel
                label="Is Featured"
                control={
                  <Switch
                    onChange={(e) =>
                      setData((pre) => ({
                        ...pre,
                        isFeatured: e.target.value,
                      }))
                    }
                  />
                }
              ></FormControlLabel> */}

              <Typography variant="caption" display="block">
                Is Featured
              </Typography>
              <FormControl
                sx={{
                  width: "100%",
                  mb: 2,
                }}
                size="small"
              >
                <Select
                  labelId="demo-simple-select-label"
                  variant="outlined"
                  name="isFeatured"
                  value={data.isFeatured}
                  onChange={(e) =>
                    setData((pre) => ({ ...pre, isFeatured: e.target.value }))
                  }
                  size="small"
                >
                  <MenuItem value="true">True</MenuItem>
                  <MenuItem value="false">False</MenuItem>
                </Select>
              </FormControl>

              {/*  <TextField
                  variant="outlined"
                  label="Is Active"
            
                  sx={{ width: "100%", mb: 2 }}
                  size="small"
                  {...register("isActive")}
                /> */}
              {/* <FormControlLabel
                label="Is Active"
                control={
                  <Switch
                    onChange={(e) =>
                      setData((pre) => ({
                        ...pre,
                        isActive: e.target.value,
                      }))
                    }
                  />
                }
              ></FormControlLabel> */}

              <Typography variant="caption" display="block">
                Is Active
              </Typography>
              <FormControl
                sx={{
                  width: "100%",
                  mb: 2,
                }}
                size="small"
              >
                <Select
                  labelId="demo-simple-select-label"
                  variant="outlined"
                  name="isActive"
                  value={data.isActive}
                  onChange={(e) =>
                    setData((pre) => ({ ...pre, isActive: e.target.value }))
                  }
                  size="small"
                >
                  <MenuItem value="active">Active</MenuItem>
                  <MenuItem value="inactive">Inactive</MenuItem>
                </Select>
              </FormControl>

              <Box sx={{ mb: 2 }}>
                <LoadingButton
                  loading={isLoading}
                  variant="contained"
                  sx={{
                    fontWeight: "600",
                    width: "100%",
                  }}
                  type="submit"
                  onClick={handleSubmit}
                >
                  Submit
                </LoadingButton>
              </Box>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default Create;
